<template>
	<div class="tp-parentdiv d-flex">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="tp-child1-div">
			<div class="boxtext d-flex align-items-center justify-content-between">
				<div class="heading-container">
					<span>Home</span>
				</div>

				<div class="d-flex">
					<div
						class="relativeclass mr-2 switchtext topic-container pointer"
						@click="topicFunction()"
						v-closable="{
							exclude: ['topicdropdown'],
							handler: 'hideTopicFunction',
						}"
					>
						<div
							class="sortcontainer d-flex justify-content-around align-items-center"
						>
							<div class="sorttext">Topic Type</div>
							<div class="sortline ml-3"></div>
							<div class="d-flex justify-content-between align-items-center">
								<div class="sortordertext ml-3 w-40">
									{{ topicCardselected }}
								</div>
								<div class="ml-3 top-downarrowAlgn">
									<img
										v-if="showtopiccard"
										src="../../assets/uparrow.svg"
										alt=""
									/>
									<img v-else src="../../assets/downarrow.svg" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="showtopiccard"
						ref="topicdropdown"
						class="relativeclass topicdashboard"
					>
						<div class="tnt-sortcard jdtypecard p-0">
							<div
								@click="showtopiccard = !showtopiccard"
								class="xMarkCancel pointer"
							>
								<img src="../../assets/xmark.svg" alt="" />
							</div>
							<b-form-group
								class="sec-mcq-datacard jdtyperadio"
								v-for="i in topicTypeOptions"
								:key="i.value"
							>
								<b-form-radio
									class="m-1"
									size="sm"
									v-model="topicCardselected"
									:value="i.text"
									@change="changeSort"
								>
									{{ i.text }}
								</b-form-radio>
							</b-form-group>
						</div>
					</div>

					<div
						class="sort-box mr-2 pl-3 pr-3 relativeclass switchtext pointer"
						@click="sortFunction()"
						v-closable="{
							exclude: ['sortdropdown'],
							handler: 'hideSortFunction',
						}"
					>
						<div>
							Sort
							<span class="ml-3">
								<img src="../../assets/sorticon.svg" alt=""
							/></span>
						</div>
					</div>
					<div
						v-if="showsortcard"
						ref="sortdropdown"
						class="relativeclass topicdashboard"
					>
						<div class="tnt-sortcard p-0 d-flex align-items-center">
							<div
								@click="showsortcard = !showsortcard"
								class="xMarkCancel pointer z-10"
							>
								<img src="../../assets/xmark.svg" alt="" />
							</div>
							<b-form-group class="sec-mcq-datacard">
								<b-form-radio
									class="sort-radio"
									v-for="(sort, index) in sort_options"
									:key="index"
									v-model="sort_selected"
									@change="changeSort"
									:value="sort.value"
								>
									{{ sort.text }}
								</b-form-radio>
							</b-form-group>
						</div>
					</div>

					<div
						class="filter-box pr-3 switchtext relativeclass pointer"
						@click="filterFunction()"
						v-closable="{
							exclude: ['filterdropdown'],
							handler: 'hideFilterFunction',
						}"
					>
						<div class="ml-3 d-flex">
							Filter
							<div class="ml-2 d-flex relativeclass">
								<span><img src="../../assets/filtericon.svg" alt="" /> </span>
								<div class="qb-filter-count" v-if="filtercount != 0">
									{{ filtercount }}
								</div>
							</div>
						</div>
					</div>
					<div v-if="showfiltercard" ref="filterdropdown" class="relativeclass">
						<div class="tnt-filtercard d-flex align-items-center">
							<div class="w-100">
								<div
									@click="showfiltercard = !showfiltercard"
									class="xMarkCancel pointer"
								>
									<img src="../../assets/xmark.svg" alt="" />
								</div>
								<div>
									<div class="topDiv mt-3">
										<label class="fieldsetStyle">Tests Count &nbsp;</label>
										<b-form-input
											id="input-1"
											min="0"
											max="1000"
											@keypress="avoidLetterE"
											class="filterinputField"
											type="number"
											v-model.trim="$v.filterdata.filtertest.$model"
											placeholder="Enter Tests Count"
										></b-form-input>
									</div>
								</div>
								<div
									class="d-flex justify-content-between align-items-center mt-3"
								>
									<div
										class="clearfilter pointer mt-3"
										:class="
											filterdata.filtertest.toString().length == 0
												? filtercount == 0
													? 'disabled-text'
													: 'pointer'
												: 'pointer'
										"
										@click="handleFilterClick"
									>
										Clear Filter
									</div>
									<div>
										<b-button
											class="addbtn"
											:disabled="filterdata.filtertest.toString().length === 0"
											@click="searchTest()"
										>
											Apply
										</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="d-flex switchtext mr-3 mt-1 pointer">
						<div class="d-flex switchParent ml-2">
							<div
								v-b-popover.hover.top="'Grid View'"
								class="switchChild"
								@click="
									LoaderStatus == true ? '' : (topicState = []),
										saveToggleView(),
										resetPagination()
								"
								:class="{
									activeSwitchLeft: !switchviews,
									notActiveSwitchLeft: switchviews,
								}"
							>
								<img src="../../assets/filtersorticon.svg" alt="" />
							</div>
							<div
								v-b-popover.hover.top="'List View'"
								class="switchChild"
								@click="
									LoaderStatus == true ? '' : (topicState = []),
										saveToggleView(),
										resetPagination()
								"
								:class="{
									activeSwitchRight: switchviews,
									notActiveSwitchRight: !switchviews,
								}"
							>
								<img src="../../assets/rightfilterwhite.svg" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<template v-if="isEmpty">
				<div class="cl-testcontainer relativeclass mr-2" id="top1">
					<div
						class="d-flex flex-column align-items-center justify-content-center h-100"
					>
						<div>
							<img src="../../assets/searchnotfound.svg" alt="" />
						</div>
						<div
							class="text-center"
							v-if="searchTopicTest != '' && searchTopicTest != 'Loader'"
						>
							<span class="searchnotfound"
								>No matching results for
								<span class="searchtext text-break">
									"{{ searchTopicTest }}"
								</span>
								.</span
							>
						</div>
						<div v-else>
							<span class="searchnotfound">No data found.</span>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div
					v-if="
						searchTopicTest == '' &&
							showAddNewCardWhenNoData &&
							!roles.includes('PUSH_TOPIC')
					"
					class="cl-testcontainer relativeclass mr-2"
				>
					<div
						class="d-flex flex-column align-items-center justify-content-center h-100"
					>
						<div>
							<img src="../../assets/searchnotfound.svg" alt="" />
						</div>
						<div>
							<span class="searchnotfound">No data found.</span>
						</div>
					</div>
				</div>
				<div v-else class="cl-testcontainer relativeclass mr-2" id="top1">
					<div class="d-flex justify-content-end">
						<b-button
							v-b-modal.topicNameModal
							@click="(updateData = null), (updatebtn = false), $v.$reset()"
							v-if="
								roles.includes('PUSH_TOPIC') &&
									topicCardselected != 'Inactive' &&
									!showAddNewCardWhenNoData &&
									searchTopicTest == ''
							"
							class="addbtn d-flex align-items-center"
						>
							<img src="../../assets/plusicon.svg" alt="" class="mr-2" />
							<span class="">Add Topic</span>
						</b-button>
					</div>
					<div>
						<div
							@click="(updateData = null), (updatebtn = false), $v.$reset()"
							class="addtopicbox d-flex justify-content-center align-items-center"
							v-b-modal.topicNameModal
							v-if="
								roles.includes('PUSH_TOPIC') &&
									topicCardselected != 'Inactive' &&
									showAddNewCardWhenNoData &&
									searchTopicTest == '' &&
									((topicCardselected == 'All' &&
										showstatisticrecord.totalTopicsCreated == 0) ||
										showstatisticrecord.activeTopics == 0)
							"
						>
							<div class="text-center pointer">
								<img src="../../assets/addsecicon.svg" alt="" />
								<div class="addtopictext mt-2">Add New Topic</div>
							</div>
						</div>
					</div>
					<div
						class="emptycard-design"
						v-if="
							roles.includes('PUSH_TOPIC') &&
								topicCardselected != 'Inactive' &&
								showAddNewCardWhenNoData &&
								searchTopicTest == '' &&
								((topicCardselected == 'All' &&
									showstatisticrecord.totalTopicsCreated == 0) ||
									showstatisticrecord.activeTopics == 0)
						"
					>
						<span>To begin creating a new topic,</span>
						<span
							>Click on "Add New Topic" button, and it will appear here for your
							viewing.</span
						>
					</div>
					<div
						class="h-100"
						v-if="topicCardselected == 'Inactive' && showAddNewCardWhenNoData"
					>
						<img
							class="h-100 w-100"
							src="../../assets/nodata.svg"
							alt="No data found"
						/>
					</div>
					<template v-if="!switchviews && !showAddNewCardWhenNoData">
						<div
							@scroll="onScroll"
							class="mt-3"
							:class="
								roles.includes('PUSH_TOPIC') && topicCardselected != 'Inactive'
									? 'topic-cards-container'
									: 'inactive-topic-cards-container'
							"
						>
							<transition-group name="cell" class="d-flex flex-wrap" tag="div">
								<div
									v-for="(i, index) in topicState"
									:key="i.topicID"
									class="tp-padng"
								>
									<TopicCard
										:showindex="index"
										:topicDetails="i"
										:type="$route.query.type"
										:sort="$route.query.sort"
										@card-option="cardoptions"
										@resetPagination="resetPagination"
										@topicEdit="topicEdit"
										@lengthofTotalTopicsWhenDeletedUpdate="inactiveTopics"
									/>
								</div>
							</transition-group>

							<div
								style="margin: auto"
								v-if="showLoader"
								class="d-flex justify-content-center mb-3"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</div>
					</template>

					<template v-if="switchviews && !showAddNewCardWhenNoData">
						<div @scroll="onScroll" class="mt-3 p-1 topic-list-card-container">
							<transition-group name="flip-list" tag="div">
								<div
									v-for="(i, index) in topicState"
									:key="i.topicID"
									:class="index != 0 ? 'mt-3' : ''"
								>
									<TopicCardGrid
										:showindex="index"
										:topicDetails="i"
										:type="$route.query.type"
										:sort="$route.query.sort"
										@card-option="cardoptions"
										@resetPagination="resetPagination"
										@topicEdit="topicEdit"
										@lengthofTotalTopicsWhenDeletedUpdate="inactiveTopics"
									/>
								</div>
							</transition-group>
							<div
								style="margin: auto"
								v-if="showLoader"
								class="d-flex justify-content-center mb-3"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</div>
					</template>
				</div>
			</template>
		</div>

		<div class="tp-child2-div" id="top1stat">
			<div class="archive-box-stats mt-2 ml-2">
				<div class="d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center">
						<img src="../../assets/icons/Archivetest/archiveicon.svg" alt="" />
						<div class="archivebox-heading ml-1">Inactive Tests</div>
					</div>
					<div class="yellownumbertext">
						{{ archivedCount }}
					</div>
				</div>
				<div
					class="view-archivetxt text-center mt-3"
					@click="gotoarchivetest"
					v-if="roles.includes('GET_TEST')"
				>
					<span class="pointer">
						View Inactive Tests
						<img
							src="../../assets/icons/Archivetest/rightarrow.svg"
							class="ml-2"
							alt=""
					/></span>
				</div>
			</div>
			<div class="tp-child2-subdiv ml-2">
				<b-overlay
					:show="showSpinner"
					variant="white"
					:opacity="overlayOpacity"
					:blur="overlayBlur"
					rounded="sm"
				>
					<div>
						<div class="statstext pt-2 mt-2 mb-2 ml-2">Statistic Overview</div>

						<div
							class="statsreview"
							v-if="Object.keys(showstatisticrecord).length > 0"
						>
							<div class="insidebox mt-1">
								<div>
									<div class="yellowcolorbar"></div>

									<div
										class="yellownumbertext"
										v-b-popover.hover.top="showstatisticrecord.activeTopics"
									>
										{{ showstatisticrecord.activeTopics }}
									</div>
									<div>Active Topics</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="greencolorbar"></div>

									<div
										class="greennumbertext"
										v-b-popover.hover.top="showstatisticrecord.archivedTopics"
									>
										{{ showstatisticrecord.archivedTopics }}
									</div>
									<div>Inactive Topics</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="bluecolorbar"></div>

									<div
										class="bluenumbertext"
										v-b-popover.hover.top="showstatisticrecord.activeTests"
									>
										{{ showstatisticrecord.activeTests }}
									</div>
									<div>Active Tests</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="yellowcolorbar"></div>
									<div
										class="yellownumbertext"
										v-b-popover.hover.top="
											showstatisticrecord.activeAutoGenTest
										"
									>
										{{ showstatisticrecord.activeAutoGenTest }}
									</div>
									<div>Active AutoGenerate Tests</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="greencolorbar"></div>
									<div
										class="greennumbertext"
										v-b-popover.hover.top="
											showstatisticrecord.archivedAutoGenTest
										"
									>
										{{ showstatisticrecord.archivedAutoGenTest }}
									</div>
									<div>Inactive AutoGenerate Tests</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="bluecolorbar"></div>
									<div
										class="bluenumbertext"
										v-b-popover.hover.top="
											showstatisticrecord.candidatesTakenTest
										"
									>
										{{ showstatisticrecord.candidatesTakenTest }}
									</div>
									<div>No. of Candidates Taken Test</div>
								</div>
							</div>
							<div class="insidebox">
								<div>
									<div class="redcolorbar"></div>
									<div
										v-b-popover.hover.top="showstatisticrecord.questionBankSize"
										class="rednumbertext"
									>
										{{ showstatisticrecord.questionBankSize }}
									</div>
									<div>Question Bank Size</div>
								</div>
							</div>
							<div class="insidebox">
								<div style="width: 80%">
									<div class="bluecolorbar"></div>
									<div
										class="bluenumbertext text-truncate"
										v-b-popover.hover.top="
											showstatisticrecord.mostActiveTopic.name
										"
									>
										{{ showstatisticrecord.mostActiveTopic.name }}
									</div>

									<div>Most Active Topic</div>
								</div>
							</div>
							<div class="insidebox">
								<div style="width: 80%">
									<div class="yellowcolorbar"></div>
									<div
										class="yellownumbertext text-truncate"
										v-b-popover.hover.top="
											showstatisticrecord.mostActiveTest.name
										"
									>
										{{ showstatisticrecord.mostActiveTest.name }}
									</div>
									<div>Most Active Test</div>
								</div>
							</div>
							<div class="insidebox">
								<div style="width: 80%">
									<div class="greencolorbar"></div>
									<div
										class="greennumbertext text-truncate"
										v-b-popover.hover.top="
											showstatisticrecord.mostActiveAutoGenTest.name
										"
									>
										{{ showstatisticrecord.mostActiveAutoGenTest.name }}
									</div>
									<div>Most Active AutoGenerate Test</div>
								</div>
							</div>
						</div>
					</div>
				</b-overlay>
			</div>

			<b-modal
				id="topicNameModal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				size="lg"
			>
				<div class="modalheading">Add Topic</div>
				<div @click="closetopicmodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<b-row
					><b-col>
						<div class="topDiv mt-3 relativeclass add-topic-parent">
							<label class="fieldsetStyle"
								>Topic Name &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								:class="{ error: $v.name.$error }"
								v-on:keyup.enter="addtopic()"
								v-model.trim="$v.name.$model"
								class="inputField"
								id="input-1"
								type="text"
								placeholder="Enter here"
								autofocus
							></b-form-input>
							<div
								class="topics-validationicon"
								v-if="$v.name.$dirty && !$v.name.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>

							<div
								class="topics-validationicon"
								v-if="!$v.name.maxLength && $v.name.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 128 characters',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								class="topics-validationicon"
								v-if="!$v.name.alpha && $v.name.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Please Enter a Valid Topic Name',
								}"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</b-col>
				</b-row>

				<div>
					<div class="topDiv mt-3 mb-2">
						<label class="fieldsetStyle">Description</label>
						<b-form-textarea
							:class="{ error: $v.description.$error }"
							v-model.trim="$v.description.$model"
							id="textarea-large"
							class="inputField"
							size="lg"
							rows="3"
							max-rows="6"
						></b-form-textarea>

						<div
							style="position: absolute; top: 5px; right: 12px"
							v-if="!$v.description.maxLength"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 512 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-end">
					<b-button
						class="addbtn mb-1 pl-3 pr-3"
						@click="addtopic()"
						v-if="updatebtn == false"
						>Save</b-button
					>
					<b-button
						class="addbtn mb-1 pl-3 pr-3"
						@click="(force = false), makeactive()"
						v-else
					>
						Save
					</b-button>
				</div>
			</b-modal>
			<b-modal id="topicsamename" centered hide-footer hide-header>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution
					<img src="../../assets/deletepopupicon.svg" alt="" />
				</div>
				<div
					@click="$bvModal.hide('topicsamename'), (updateData = null)"
					class="xMarkCancel"
				>
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div class="mt-3">
					<div class="topicsamename-modal-text mt-2">
						<img src="../../assets/noteicon.svg" alt="" />

						<span class="ml-2 topiccaution-txt"
							>"Topic
							<span class="topicsamename-topic"> "{{ name }}" </span>
							is already exists in inactive list".
						</span>
					</div>
					<div class="topicsamename-modal-text mt-3 mb-3">
						Do you want to reactivate the topic "{{ name }}" or add it as a new
						topic?
					</div>
					<b-form-radio-group
						class="topics-caution-option"
						:options="updatedataoptions"
						value-field="item"
						text-field="name"
						disabled-field="notEnabled"
						v-model="updateData"
					></b-form-radio-group>

					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button
							class="addbtn pl-3 pr-3"
							@click="gotoparticularpage"
							:disabled="updateData == null"
						>
							Next
						</b-button>
					</div>
				</div>
			</b-modal>
			<b-modal id="inactivetopics" centered hide-footer hide-header size="md">
				<div v-if="showmodal">
					<div class="modalheading">
						<span>Activate Test</span>
					</div>
					<div @click="$bvModal.hide('inactivetopics')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<hr />
					<div
						style="margin: auto"
						v-if="showLoader"
						class="d-flex justify-content-center mb-3"
					>
						<b-spinner label="Loading..."></b-spinner>
					</div>
					<div v-else>
						<div>
							<div class="tcg-modal-grey p-2">
								<div class="tcg-modal-head">Topic name</div>
								<div class="d-flex align-items-center justify-content-between">
									<div class="tcg-modal-head-2">{{ this.theTopicName }}</div>
									<div class="graph-subtext">
										Total Test : <b>{{ totalTestCount }}</b>
									</div>
								</div>
							</div>

							<div class="mt-3 answertext">
								Please select the tests you would like to activate for this
								topic.
							</div>
						</div>
						<div class="tcg-modal-overflow">
							<!-- WHEN TOPIC IS ACTIVE -->

							<!-- WHEN TOPIC IS INACTIVE -->

							<div
								v-for="(i, index) in totalTestArr"
								:key="index"
								class="tcg-modal-card m-2"
							>
								<div class="d-flex align-items-center justify-content-between">
									<div class="tcg-test-name pt-1">
										{{ i.name }}
									</div>
									<div
										class="tcg-deactivate-box d-flex align-items-center justify-content-between p-1"
									>
										<div
											@click="toggleActivate(index, i)"
											:class="
												i.view
													? 'tcg-active-text-green pointer'
													: 'tcg-disable-text pointer'
											"
										>
											Activate
										</div>

										<div
											@click="toggleActivatenext(index, i)"
											:class="
												i.view
													? 'tcg-disable-text pointer'
													: 'tcg-active-text-red pointer'
											"
											class="tcg-disable-text pointer"
										>
											Deactivate
										</div>
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-3 pr-2"
								>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="topic-gt-tctxt mr-2">Candidates</div>
										<div class="topic-gt-tccounttxt">
											{{ actualres.testIDs[index].candidateCount }}
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="topic-gt-tctxt mr-2">Sections</div>
										<div class="greennumbertext">
											{{ actualres.testIDs[index].numberOfSections }}
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="topic-gt-tctxt mr-2">Marks</div>
										<div class="proct-gt-candcounttxt">
											{{ actualres.testIDs[index].marks }}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="d-flex justify-content-end mt-3">
							<b-button @click="gotoparticulartopicdetails()" class="addbtn">
								<span>Okay</span>
							</b-button>
						</div>
					</div>
				</div>
				<div v-else>
					<div
						class="modalheading d-flex align-items-center justify-content-between modal-text"
					>
						Caution
					</div>
					<div @click="$bvModal.hide('inactivetopics')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>

					<hr />

					<div class="mt-3">
						<div class="topicsamename-modal-text mt-2">
							<img src="../../assets/noteicon.svg" alt="" />

							<span class="ml-2 inactivetopicname-text"
								>This topic
								<span class="topicsamename-topic"> "{{ name }}" </span>
								with same topic name already exists in inactive list.
							</span>
						</div>
						<div class="inactivetopicname-text mt-3 ml-2">
							Please confirm the topic that you want to activate based on other
							details.
						</div>
					</div>
					<div class="topicdata-size mt-2">
						<div
							class="d-flex align-items-center"
							v-for="(i, index) in activetopic"
							:key="i.topicID"
							@click="selectedtopic = i"
							:class="{
								'inactive-selected-box': selectedtopic.topicID == i.topicID,
								'mt-0': index == 0,
								'mt-3': index != 0,
								'inactivecust-detail-box': selectedtopic.topicID != i.topicID,
							}"
						>
							<div></div>
							<div style="width: 100%" class="d-flex pointer">
								<div class="d-flex flex-column" style="width: 60%">
									<div class="tp-text tp-cardhead">
										{{ i.name }}
									</div>
									<div class="pointer">
										<div
											class="topicDescBreak"
											v-if="i.description.length != 0"
										>
											{{ i.description | snippet }}
										</div>
										<div
											v-else
											class="d-flex align-items-center justify-content-start"
										>
											<div>
												<img src="../../assets/nodataicon.svg" alt="" />
											</div>
											<div class="topicDescBreak" style="font-size: 12px;">
												Description not available
											</div>
										</div>
									</div>
								</div>

								<div
									class="d-flex flex-column align-items-center"
									style="width: 10%"
								>
									<span class="tp-cardhead">Tests</span>
									<span v-if="i.testCount < 10" class="greennumbertext"
										>0{{ i.inActiveTestCount }}</span
									>
									<span v-else class="greennumbertext">{{
										i.inActiveTestCount
									}}</span>
								</div>

								<div
									class="d-flex flex-column align-items-center"
									style="width: 30%"
								>
									<span class="tp-cardhead">Candidates</span>
									<span v-if="i.candidateCount < 10" class="yellownumbertext"
										>0{{ i.candidateCount }}</span
									>
									<span v-else class="yellownumbertext">{{
										i.candidateCount
									}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-4 d-flex justify-content-end">
						<b-button
							v-if="selectedtopic.inActiveTestCount == 0"
							class="addbtn pl-3 pr-3"
							@click="gotoparticulartopicdetails()"
							:disabled="selectedtopic.hasOwnProperty('topicID') == false"
							>Activate Topic
						</b-button>

						<b-button
							v-else
							class="addbtn pl-3 pr-3"
							@click="getActivateTests()"
							:disabled="selectedtopic.hasOwnProperty('topicID') == false"
							>Activate Topic
						</b-button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.14.1/lodash.min.js"></script>
<script>
import TopicCardGrid from "./gridview/TopicCardGrid.vue";
import TopicCard from "./cardview/TopicCard.vue";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import {
	tabRedirect,
	onScroll,
	resetPagination,
	topicEdit,
	changeSort,
	cardoptions,
	simple,
	topicFunction,
	hideTopicFunction,
	sortFunction,
	hideSortFunction,
	filterFunction,
} from "../../controllers/topics/helpers";
import {
	getArchivedTest,
	getDataBasedOnLazyLoadingInHomePage,
	getTestOrgPagination,
	postTopic,
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

import {
	required,
	maxLength,
	between,
	helpers,
} from "vuelidate/lib/validators";
import toast from "../mixin/toast.js";
import { getStatisticReports } from "../../controllers/topics/asynchronous";
export default {
	name: "Topics",
	mixins: [toast],
	data() {
		return {
			filtertestFix: "",
			name: "",
			description: "",
			theTopicName: "",
			filterdata: {
				filtertest: "",
			},
			storefilterdata: {
				filtertest: "",
			},
			filtrname: "",
			activeForTopic: "1",
			overlayBlur: "4",
			sort_selected: "4",
			topicCardselected: "Active",
			sortColumn: "createdAt",
			totalTestCount: 0,
			page: 0,
			count: 50,
			overlayOpacity: 0.46,
			filtercount: 0,
			topicnum: 0,
			sortorder: -1,
			testCount: 0,
			total: null,
			pageEnd: null,
			updateData: null,
			force: null,
			archivedCount: null,
			showSpinner: false,
			showtopiccard: false,
			updatebtn: false,
			showmodal: false,
			showLoader: false,
			LoaderStatus: false,
			showAddNewCardWhenNoData: false,
			showfiltercard: false,
			showsortcard: false,
			active: true,
			actualres: {},
			selectedtopic: {},
			allTestIds: [],
			totalTestArr: [],
			topicState: [],
			activetopic: [],
			// PAYLOAD FOR STATE
			topic: {
				id: "",
				name: "",
				description: "",
				testCount: 0,
				active: true,
			},
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			filteroptions: [
				{
					item: "true",
					name: "Yes",
				},
				{
					item: "false",
					name: "No",
				},
			],
			updatedataoptions: [
				{
					item: false,
					name: "Activate the Topic",
				},
				{
					item: true,
					name: "Add New Topic",
				},
			],
			sort_options: [
				{ text: "Topic(Asc)", value: "1" },
				{ text: "Topic(Desc)", value: "2" },
				{ text: "Date Created(Asc)", value: "3" },
				{ text: "Date Created(Desc) (Default)", value: "4" },
				{ text: "Date Modified(Asc)", value: "5" },
				{ text: "Date Modified(Desc)", value: "6" },
			],
			topicTypeOptions: [
				{ text: "All", value: "2" },
				{ text: "Active", value: "1" },
				{ text: "Inactive", value: "0" },
			],
		};
	},
	validations: {
		name: {
			required,
			maxLength: maxLength(128),
			alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
		},
		description: {
			maxLength: maxLength(512),
		},
		filterdata: {
			filtertest: {
				between: between(0, 1000),
				alpha: helpers.regex("alph", /^[0-9]*$/),
			},
		},
	},
	created() {
		this.LoaderStatus = true;
		// this.$store.dispatch("topicVUEX/getStatisticReport");
		this.$store.commit("searchVUEX/saveSearchTopicTest", "");
		// this.clearFilterModels();
		// Managing tab redirect based on Customer type and Sort
		this.sort_selected = "4";
		this.$router.replace({
			name: "Home",
			query: {
				type: this.topicCardselected,
				sort: "4",
			},
		});
		this.tabRedirect();
		this.getArchivedTest();
		getStatisticReports(this);
	},
	beforeDestroy() {
		window.removeEventListener("popstate", this.handleBackButton);
	},
	computed: {
		...mapGetters("topicVUEX", {
			showstatisticrecord: "getshowstatisticrecord",
		}),
		...mapGetters("searchVUEX", {
			list: "getListView",
			grid: "getGridView",
			switchviews: "getToggleView",
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters(["roles"]),
		isEmpty() {
			var temp;
			if (this.searchTopicTest == "") {
				temp = false;
			} else if (this.searchTopicTest != "" && this.topicState.length == 0) {
				temp = true;
			}
			if (this.filterdata.filtertest != "") {
				if (this.topicState.length == 0) {
					temp = true;
				}
			} else if (this.filtertestFix != this.filtercount) {
				if (this.topicState.length == 0) {
					temp = true;
				}
			}
			return temp;
		},
	},

	watch: {
		getshowstatisticrecord(newValue, oldValue) {
			if (newValue != oldValue) {
				showstatisticrecord = newValue;
			}
		},
		searchTopicTest(newValue, oldValue) {
			let timer = 200;
			setTimeout(() => {
				if (newValue != oldValue) {
					this.resetPagination();
				}
			}, timer);
		},
		// Watch for these variables for Tab Redirect
		topicCardselected() {
			this.pageEnd = 0;
			this.$router.push({
				name: `Home`,
				query: {
					type: this.topicCardselected,
					sort: this.sort_selected,
				},
			});
		},
		sort_selected() {
			this.$router.push({
				name: `Home`,
				query: {
					type: this.topicCardselected,
					sort: this.sort_selected,
				},
			});
		},
		getTopicDetails: function() {
			this.topicState = this.getTopicDetails;
		},
		getListView: function() {
			this.list = this.getListView;
		},
		getGridView: function() {
			this.grid = this.getGridView;
		},
	},
	components: {
		TopicCard,
		TopicCardGrid,
		Spinner,
		// SearchBar,
		// ComingSoon
	},
	mounted() {
		const el = document.getElementById("top1");
		const el1 = document.getElementById("top1stat");
		el.addEventListener("click", this.simple, false);
		el1.addEventListener("click", this.simple, false);
		let referrer = document.referrer;
		if (
			document.referrer.includes("/login") ||
			!referrer.startsWith(window.location.origin)
		) {
			history.pushState(null, document.title, location.href);
			window.addEventListener("popstate", this.handleBackButton);
		}
	},
	methods: {
		inactiveTopics() {
			this.getArchivedTest();
		},
		handleBackButton(event) {
			history.pushState(null, document.title, location.href);
		},
		handleFilterClick() {
			if (this.filterdata.filtertest.toString().length === 0) {
				this.filtercount === 0
					? this.clearfilterbox()
					: this.clearFilterModels();
			} else {
				this.filtercount === 0
					? this.clearfilterbox()
					: this.clearFilterModels();
			}
		},
		avoidLetterE(event) {
			const key = event.key;
			const maxLength = 3;
			var numbersRegex = /^[0-9]+$/;
			const hasDecimal = this.filterdata.filtertest.includes(".");
			if (
				key.toLowerCase() === "e" ||
				hasDecimal ||
				key === "." ||
				this.filterdata.filtertest.length >= maxLength ||
				!numbersRegex.test(key)
			) {
				event.preventDefault();
			}
		},

		...mapMutations("searchVUEX", {
			saveToggleView: "saveToggleView",
		}),
		gotoarchivetest() {
			this.$router.push({
				path: "/archivetest",
				query: {
					type: this.topicCardselected,
					sort: this.sort_selected,
				},
			});
		},
		// Managing tab redirect based on Customer type and Sort
		tabRedirect() {
			tabRedirect(this);
		},
		async getTopics() {
			try {
				var payload = {
					searchQuery: this.searchTopicTest,
					sortBy: this.sortColumn,
					order: this.sortorder,
					type: this.activeForTopic,
					testCount: this.filterdata.filtertest,
					page: this.page,
					count: this.count,
				};
				if (payload.sortBy == null) {
					delete payload.sortBy;
					delete payload.order;
				}
				if (payload.testCount.toString().length === 0) {
					delete payload.testCount;
				}
				if (payload.searchQuery == "") {
					delete payload.searchQuery;
				}
				let res = await getDataBasedOnLazyLoadingInHomePage(payload);
				if (res.status == 200) {
					if (res.data.data.topicIDs.length !== 0) {
						if (this.page == 0) {
							this.topicState = res.data.data.topicIDs.map((data) => {
								return { ...data, editoption: false };
							});
						} else {
							let data = res.data.data.topicIDs.map((data) => {
								return { ...data, editoption: false };
							});
							this.topicState = [...this.topicState, ...data];
						}
						res.data.data.total == res.data.data.pageEnd
							? (this.showLoader = false)
							: (this.showLoader = true);

						// let totalData = [...this.topicState, ...addEditOption];
						// this.topicState = totalData;
						// this.showAddNewCardWhenNoData = false;
					} else if (res.data.data.total == 0) {
						this.topicState = res.data.data.topicIDs;
					}
					this.total = res.data.data.total;
					this.pageEnd = res.data.data.pageEnd;
					this.total === 0
						? (this.showAddNewCardWhenNoData = true)
						: (this.showAddNewCardWhenNoData = false);
				}
				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! ! status: ${error.status}`);
			}
		},
		async getArchivedTest() {
			try {
				let payload = {
					type: 0,
					count: 1,
					page: 0,
				};
				const res = await getArchivedTest(payload);
				if (res.status == 200) {
					this.archivedCount = res.data.data.total;
				}
			} catch (error) {
				console.log(error);
			}
		},
		onScroll(e) {
			// Get the target element of the scroll event.
			onScroll(e, this);
		},
		toggleActivate(index, allTestValue) {
			this.totalTestArr[index].view = true;
			this.$forceUpdate();
			let currentTestId = allTestValue.testID;
			if (this.allTestIds.includes(currentTestId)) {
				null;
			} else {
				this.allTestIds.push(allTestValue.testID);
			}
		},
		toggleActivatenext(index, allTestValue) {
			this.totalTestArr[index].view = false;
			this.$forceUpdate();
			let currentTestId = allTestValue.testID;
			const Currentindex = this.allTestIds.indexOf(currentTestId);

			if (this.allTestIds.includes(currentTestId)) {
				this.allTestIds.splice(Currentindex, 1);
			}
		},
		async getActivateTests() {
			// this.$bvModal.hide("topicsamename");
			// this.$bvModal.hide("topicNameModal");
			this.showmodal = true;
			// this.$bvModal.show("design-modal");
			this.selectedtopic.active = true;
			this.selectedtopic.force = true;
			this.showLoader = true;
			let payload = {
				topicID: this.selectedtopic.topicID,
				sortBy: this.sortColumn,
				order: this.sortorder,
				type: 2,
				page: 0,
				count: "all",
			};
			const res = await getTestOrgPagination(payload);
			this.actualres = res.data.data;
			this.totalTestArr = this.actualres.testIDs;
			this.showLoader = false;
			if (this.actualres.total === 0) {
				this.theTopicName = "No Topics Created";
			} else {
				this.theTopicName = this.actualres.topicName;
			}
			this.totalTestCount = this.actualres.total;

			for (let i = 0; i < this.totalTestArr.length; i++) {
				this.totalTestArr[i].view = null;
			}
		},
		// function will be called when need to reset lazy loading
		resetPagination() {
			resetPagination(this);
		},
		topicEdit(data, cloneData) {
			topicEdit(data, cloneData, this);
		},
		// Function to display data based on Sort and Topic type
		changeSort() {
			changeSort(this);
		},
		//Making inactive  in to active
		gotoparticularpage() {
			if (this.updateData == false) {
				this.LoaderStatus = false;
				this.$bvModal.show("inactivetopics");
			} else {
				this.LoaderStatus = false;
				this.updatebtn = true;
				this.$bvModal.show("topicNameModal");
				this.$bvModal.hide("topicsamename");
			}
			this.selectedtopic = {};
			this.showmodal = false;
		},
		//Making inactive  in to active
		async gotoparticulartopicdetails() {
			this.selectedtopic.active = true;
			this.selectedtopic.force = true;
			this.selectedtopic["testIDs"] = this.allTestIds;
			const res = await postTopic(this.selectedtopic);
			if (res.status == 200) {
				this.$bvModal.hide("topicsamename");
				this.$bvModal.hide("topicNameModal");
				this.$bvModal.hide("inactivetopics");
				this.successToast("Topic activated successfully!");
				this.clearTopicModalData();
				this.resetPagination();
			} else {
				this.errorToast("Something  went wrong!");
			}
			this.selectedtopic = {};
			this.getArchivedTest();
		},
		//Making inactive  in to active
		async makeactive() {
			this.topic.portion = "Topic";
			this.topic.force = false;
			const res = await postTopic(this.topic);
			if (res.status == 200) {
				this.getTopics();
				this.updatebtn = false;
				this.updateData = null;
				this.$bvModal.hide("topicNameModal");
				this.$nextTick(() => {
					this.successToast("Topic created successfully!");
				});
				this.clearTopicModalData();
			} else if (res.status == 404) {
				this.errorToast(res.data.data.Data);
			} else if (res.status == 409) {
				this.activetopic = res.data.data.topics;
			} else {
				this.errorToast(`${res.data.data.Details}`);
			}
			this.$bvModal.hide("topicsamename");
		},
		simple() {
			simple(this);
		},
		topicFunction() {
			topicFunction(this);
		},
		hideTopicFunction() {
			hideTopicFunction(this);
		},
		sortFunction() {
			sortFunction(this);
		},
		hideSortFunction() {
			hideSortFunction(this);
		},
		filterFunction() {
			filterFunction(this);
		},
		hideFilterFunction() {
			this.showfiltercard = false;
			this.filterdata.filtertest = this.filtertestFix;
			this.$v.filterdata.filtertest.$reset();
		},
		// getTopicValue(data) {
		//   this.activeForTopic = data;
		//   this.showtopiccard = false;
		//   this.resetPagination();
		// },
		// props function to close  options on  card
		cardoptions(data, val) {
			cardoptions(data, val, this);
		},
		clearfilterbox() {
			this.$v.filterdata.filtertest.$reset();
			this.filterdata.filtertest = "";
			this.filtertestFix = "";
			this.showfiltercard = true;
			// this.topicState = [];
			this.page = 0;
			this.showLoader = false;

			// this.LoaderStatus = true;
			//this.getTopics();
		},
		clearFilterModels() {
			this.$v.filterdata.filtertest.$reset();
			this.filterdata.filtertest = "";
			this.storefilterdata = {
				filtertest: "",
			};
			this.filtertestFix = "";
			this.filtercount = 0;
			this.showfiltercard = false;
			this.resetPagination();
		},
		searchTest() {
			this.storefilterdata = { ...this.filterdata };
			this.filtercount = 0;
			if (this.filterdata.filtertest.toString() != "") {
				this.filtercount++;
			}
			this.showfiltercard = false;
			this.filtertestFix = this.filterdata.filtertest;
			this.resetPagination();
		},
		async addtopic() {
			try {
				this.$v.name.$touch();
				this.$v.description.$touch();
				if (this.$v.name.$invalid) {
					this.errorToast("Please fill all the mandatory fields");
				} else if (!this.$v.name.$invalid && !this.$v.description.$invalid) {
					this.topic.topicID = this.topicnum;
					this.topic.portion = "Topic";
					this.topic.name = this.name;
					this.topic.description = this.description;
					this.topic.active = this.active;
					this.topic.testCount = 0;
					this.topic.candidateCount = 0;
					this.topic.editoption = false;
					this.topic.publicAvailability = false;
					this.topicnum += 1;
					this.$v.$reset();
					const res = await postTopic(this.topic);
					if (res.status == 200) {
						this.successToast("Topic created successfully!");
						this.$bvModal.hide("topicNameModal");
						document.getElementById("headerSearch").value = "";
						this.$store.commit("searchVUEX/saveSearchTopicTest", "");
						getStatisticReports(this);
						this.resetPagination();
						this.$nextTick(() => {
							this.clearTopicModalData();
						});
					} else if (res.status == 409) {
						this.activetopic = res.data.data.topics;
						this.$bvModal.show("topicsamename");
					} else if (res.status == 404) {
						this.$bvModal.hide("topicNameModal");
						this.errorToast(`${res.data.data.Data}`);
					} else if (res.status == 208) {
						this.errorToast(`${res.data.data.Data}`);
					} else {
						this.$bvModal.hide("topicNameModal");
						this.errorToast("Something went wrong !");
					}
				}
			} catch (error) {
				this.$bvModal.hide("topicNameModal");
				this.errorToast("Something went wrong !");
				throw error;
			}
		},
		closetopicmodal() {
			this.$bvModal.hide("topicNameModal");
			this.clearTopicModalData();
		},
		clearTopicModalData() {
			this.topicnum = 0;
			this.name = "";
			this.description = "";
			this.topic = {
				id: "",
				name: "",
				description: "",
				testCount: 0,
				active: true,
			};
			this.$v.$reset();
			// this.active = false;
		},
		listView() {
			this.list = true;
			this.grid = false;
		},
		gridView() {
			this.list = false;
			this.grid = true;
		},
	},
};
</script>

<style scoped>
.tnt-sortcard .custom-control {
	padding-left: 2rem !important;
	padding-top: 5px;
	padding-bottom: 5px;
}

.sort-radio:nth-child(even) {
	background: #fdfdfd;
}

.sort-radio:nth-child(odd) {
	background: #f4f4f4;
}

#savebutton {
	margin-left: 700px;
}

.heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 27px;
	height: 20px;
	top: 3px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}

.flip-list-move {
	transition: transform 1s;
}

.topicsamename-modal-text {
	font-weight: 400;
	font-size: 14px;
	color: #8a8b8c;
}

.topicsamename-topic {
	color: #3471cd;
}

.topiccaution-txt {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;

	color: #696969;
}

.inactivetopicname-text {
	font-family: "Poppins", sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0em;
	text-align: left;
}

.caution-option {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
}

.topics-caution-option {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	color: #696969;
}

.sortcontainer {
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border: 1px solid #72738e;

	border-radius: 3px;
	padding: 5px 15px;
	text-align: left;
}

.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}

.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}

.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}

.cell:nth-child(3n) {
	margin-right: 0;
}

.cell:nth-child(27n) {
	margin-bottom: 0;
}

.cell-move {
	transition: transform 1s;
}

.tp-text {
	position: relative;
}

.tp-cardhead {
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-primary);
}

.topicDescBreak {
	word-break: break-all;
}

.topicdata-size {
	min-height: auto;
	max-height: calc(100vh - 395px);
	overflow: auto;
	padding: 5px;
}

.inactive-selected-box {
	background: #e2e7fd;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.3);
	border-radius: 5px;
	color: #696969;
	margin: 5px;
	padding: 10px;
}

.inactivecust-detail-box {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	color: #696969;
	margin: 5px;
	padding: 10px;
}

.tp-gridcard {
	background: #fbfbfb;
	border: 0.7px solid var(--bg-backgroundcolor);
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	height: 0px;
	padding: 15px;
}

.modal-text {
	height: 16px;
	width: 50px;
	left: 365px;
	top: 110px;
	border-radius: nullpx;
}

.sort-box {
	border: 1px solid #72738e;
	padding-top: 5px;

	border-radius: 3px;
}

.filter-box {
	border: 1px solid #72738e;
	padding: 5px;

	border-radius: 3px;
}

.heading-container {
	position: relative;
	z-index: 1;
}

.boxtext {
	font-weight: var(--weight-M);
	font-size: var(--size-18);
	color: var(--headtext) !important;
}

.topic-container {
	width: 240px;
}

.activate-options-text {
	color: #696969;
	font-weight: 500;
	font-size: 14px;
}

.qb-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 8px;
	position: absolute;
	top: -5px;
	right: -15px;
}

.top-downarrowAlgn {
	margin-bottom: 2px;
}

.add-topic-parent .form-control.error:focus {
	border: 1px solid red !important;
	font-size: 12px !important;
}

.topics-validationicon {
	position: absolute;
	top: 2px;
	right: 12px;
	background: var(--bg-white);
}
</style>
